import { isValidPhoneNumber, parsePhoneNumber } from 'libphonenumber-js';

export const formatPhoneNumber = (phoneNumber?: string) => {
  if (!phoneNumber) return '';

  const format = (pn: string) => parsePhoneNumber(pn).formatInternational();
  const withPrefixedPlus = `${'+'}${phoneNumber}`;
  if (isValidPhoneNumber(withPrefixedPlus)) return format(withPrefixedPlus);
  if (isValidPhoneNumber(phoneNumber)) return format(phoneNumber);

  return phoneNumber;
};
